import React from 'react';
import { FiArrowLeft } from "react-icons/fi";
import Logo from "../../../../../assets/home/logo.svg";

const SolutionsHeader = ({ onBack }) => (
    <div className="w-full bg-white h-[64px] md:h-[74px] border-b border-[#E0E0E0] sticky top-0 z-50">
        <div className="w-full max-w-[1400px] mx-auto px-4 lg:px-6 h-full flex items-center justify-between relative">
            <img src={Logo} alt="BaapBola" className="h-8 md:h-10 w-auto object-contain" />
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center hidden md:block">
                <h1 className="text-[18px] font-semibold text-[#333]">Detailed Solutions</h1>
                <p className="text-[13px] text-[#33333399]">SSC CGL Tier-I Mock Test 15 • All Solutions</p>
            </div>
            <button
                onClick={onBack}
                className="bg-[#4096F6] text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full text-[12px] md:text-[14px] font-semibold flex items-center gap-1.5 md:gap-2 hover:bg-[#3488e5] transition-all whitespace-nowrap"
            >
                <FiArrowLeft className="text-[16px]" />
                <span className="hidden sm:inline">Back to Results</span>
                <span className="sm:hidden">Back</span>
            </button>
        </div>
    </div>
);

export default SolutionsHeader;